import React from 'react'
import VolumeRetrieveListing from './VolumeRetrieveListing'
import VolumeFilterForm from './VolumeFilterForm'
import { FilterDataProvider } from '../../HOC/volumeReportFiltersContext'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function VolumeRetrieve() {
  SetTitle('Market Screener')
  return (
    <FilterDataProvider>
      <Header
        iconClass="fa-solid fa-chart-line fa-xl"
        title="Market Screener"
        docLink="/docs/ranking_tools/market-screener/"
        headerClassName="main-page-title"
        headerChildren={<VolumeFilterForm />}
      >
        <VolumeRetrieveListing />
      </Header>
    </FilterDataProvider>
  )
}